import '../auth.scss';

import { verify2faCode } from '@basqet-dashboard/common/api';
import { ReactComponent as Logo } from '@basqet-dashboard/common/assets/logo.svg';
import { Button, FormInput } from '@basqet-dashboard/common/components';
import { APP_NAME } from '@basqet-dashboard/common/config';
import { UserContext } from '@basqet-dashboard/common/context';
import { useDocumentTitle, useSessionStorage } from '@basqet-dashboard/common/hooks';
import { formatErrorMessage, twoFASchema } from '@basqet-dashboard/common/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';

function TwoFactorCode() {
  const { setUser } = useContext(UserContext);
  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isDirty }
  } = useForm({ mode: 'onChange', resolver: yupResolver(twoFASchema) });

  useDocumentTitle('Secure Login');
  const [isLoading, setIsLoading] = useState(false);
  const [, setToken] = useSessionStorage(APP_NAME, '');

  const onSubmit = async (body) => {
    setIsLoading(true);
    try {
      const { data } = await verify2faCode(body);
      const { accessToken, merchantUser } = data;
      setToken({ token: accessToken, merchantUser, TwoFaEnabled: true });
      setUser(merchantUser);
      window.location.replace('/');
    } catch (error) {
      formatErrorMessage(error);
      setIsLoading(false);
    }
  };

  return (
    <main className="auth">
      <Logo />
      <div className="auth__content">
        <div className="auth__card">
          <h1 className="page__title">
            2 Factor <span className="text-cursive">Authentication</span>
          </h1>
          <p className="page__description">
            Please enter the access code from your Authenticator App
          </p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormInput
              label="2FA access code"
              placeholder="Enter your code here"
              name="code"
              type="tel"
              error={errors.code && errors.code.message}
              register={register('code')}
            />
            <Button disabled={!isValid || !isDirty} isFull type="submit" isLoading={isLoading}>
              Login
            </Button>
          </form>
        </div>
      </div>
    </main>
  );
}

export { TwoFactorCode };
